<template>
    <div class="books-list">
        <div class="books-list__search search-input">
            <input
                v-model="searchString"
                type="text"
                autofocus
                class="search-input__input"
                :placeholder="$t('booksList.searchPlaceholder')"
                @keyup="onSearchInput"
            />
        </div>
        <transition name="fade" appear>
            <div v-if="selectedBooks.length" class="contracted-selected">
                <Spinner v-if="loadingSend" />
                <span style="position: absolute; top: -12px">
                    Выбраны (ISBN - Контр.):&nbsp;
                    <a
                        href="#"
                        class="link"
                        style="margin-left: 84px; display: inline"
                        @click.prevent="selectedBooks = []"
                    >
                        Очистить
                    </a>
                </span>
                <ul class="contracted-selected__list">
                    <li
                        v-for="item in selectedBooks"
                        :key="item.id"
                        class="contracted-selected__item"
                    >
                        {{ item.isbnx }} - {{ item.contractorName }}
                        <button
                            type="button"
                            class="category-list__item-del"
                            @click.prevent="onBookSelected(item)"
                        >
                            <svg
                                width="8"
                                height="8"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 512 512"
                                style="pointer-events: none"
                            >
                                <path
                                    d="M505.943 6.058c-8.077-8.077-21.172-8.077-29.249 0L6.058 476.693c-8.077 8.077-8.077 21.172 0 29.249A20.612 20.612 0 0020.683 512a20.614 20.614 0 0014.625-6.059L505.943 35.306c8.076-8.076 8.076-21.171 0-29.248z"
                                />
                                <path
                                    d="M505.942 476.694L35.306 6.059c-8.076-8.077-21.172-8.077-29.248 0-8.077 8.076-8.077 21.171 0 29.248l470.636 470.636a20.616 20.616 0 0014.625 6.058 20.615 20.615 0 0014.624-6.057c8.075-8.078 8.075-21.173-.001-29.25z"
                                />
                            </svg>
                        </button>
                    </li>
                </ul>
                <div style="display: flex; justify-content: space-around">
                    <button type="button" class="button" :disabled="loadingSend" @click="sendMeta">
                        Отправить мета
                    </button>
                    <button type="button" class="button" :disabled="loadingSend" @click="sendBook">
                        Отправить книги
                    </button>
                </div>
                <div
                    style="
                        display: flex;
                        justify-content: space-around;
                        align-items: center;
                        margin-top: 10px;
                    "
                >
                    <span style="font-size: 10px">Статус:</span>
                    <CustomSelect
                        v-model="state"
                        compact
                        class="select--small"
                        :options="states"
                        emit-prop="name"
                        view-label="label"
                        width="117px"
                    />
                    <button
                        type="button"
                        class="button"
                        :disabled="loadingSend || !state"
                        :class="{ 'is-disabled': loadingSend || !state }"
                        @click="setState"
                    >
                        Ok
                    </button>
                </div>
            </div>
        </transition>
        <Spinner v-if="loading" class="spinner--gray" />
        <div style="max-width: 840px">
            <table class="control-table">
                <thead class="control-table__head">
                    <tr class="control-table__row">
                        <th class="control-table__cell" style="width: 7%">
                            <Checkbox v-model="allSelected" />
                        </th>
                        <th class="control-table__cell">
                            {{ $t('adminBookControls.book') }} ({{ booksCount }})
                        </th>
                        <th class="control-table__cell" style="width: 12%">
                            {{ $t('adminBookControls.buildType') }}
                        </th>
                        <th class="control-table__cell" style="width: 15%">
                            <div style="display: flex">
                                {{ $t('adminBookControls.contractor') }}
                                <VDropdown>
                                    <button
                                        type="button"
                                        style="
                                            border: none;
                                            cursor: pointer;
                                            background: none;
                                            padding: 0;
                                            outline: none;
                                            margin-left: 2px;
                                            transform: scale(0.8) translateY(2px);
                                        "
                                    >
                                        <svg
                                            width="16"
                                            height="16"
                                            viewBox="0 0 16 16"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                            @click.prevent
                                        >
                                            <path
                                                fill-rule="evenodd"
                                                clip-rule="evenodd"
                                                d="M15.9501 7.11169C15.9248 6.88678 15.6626 6.71777 15.4358 6.71777C14.7027 6.71777 14.0522 6.2873 13.7793 5.62156C13.5006 4.93968 13.6803 4.14446 14.2267 3.64326C14.3987 3.48604 14.4196 3.22285 14.2753 3.04003C13.9001 2.56354 13.4736 2.13313 13.008 1.7601C12.8256 1.61377 12.5581 1.63413 12.4 1.80921C11.9231 2.33732 11.0666 2.53359 10.4047 2.25743C9.71594 1.96769 9.28159 1.26974 9.3241 0.520533C9.33809 0.285204 9.1661 0.0805941 8.93149 0.0532691C8.33391 -0.0158471 7.73109 -0.0179902 7.13173 0.0485066C6.8998 0.0741052 6.72781 0.273893 6.73561 0.506245C6.76168 1.24807 6.3221 1.93381 5.64017 2.21314C4.98621 2.48025 4.13568 2.28565 3.65979 1.76224C3.50251 1.58984 3.23932 1.56865 3.05608 1.71146C2.57661 2.08764 2.14054 2.51841 1.76186 2.99098C1.61417 3.17469 1.6359 3.44098 1.80961 3.59903C2.36641 4.10326 2.54619 4.90539 2.25693 5.59513C1.98076 6.25271 1.29793 6.67652 0.516226 6.67652C0.262562 6.66836 0.0818834 6.83862 0.0541417 7.06925C-0.0162246 7.67028 -0.0170581 8.28268 0.0506889 8.88859C0.0758112 9.11446 0.346025 9.28198 0.575281 9.28198C1.27192 9.26418 1.94076 9.69549 2.22133 10.3783C2.50101 11.0601 2.32122 11.8549 1.77401 12.3565C1.60286 12.5137 1.58113 12.7765 1.72537 12.9593C2.09709 13.4328 2.52363 13.8636 2.99095 14.2397C3.17425 14.3874 3.44095 14.3666 3.59984 14.1915C4.07848 13.6621 4.93496 13.4662 5.59421 13.7429C6.28471 14.0317 6.71906 14.7296 6.67655 15.4792C6.66268 15.7147 6.8355 15.9196 7.06916 15.9465C7.37486 15.9822 7.6824 16 7.99077 16C8.28349 16 8.57626 15.9839 8.86898 15.9514C9.10097 15.9258 9.27284 15.726 9.26504 15.4932C9.23819 14.7518 9.67855 14.0661 10.3596 13.7872C11.018 13.5183 11.8649 13.7151 12.3409 14.238C12.499 14.41 12.7604 14.4308 12.9446 14.2885C13.4232 13.9132 13.8584 13.4828 14.2388 13.0089C14.3865 12.8256 14.3656 12.5589 14.191 12.4009C13.6342 11.8967 13.4536 11.0944 13.7428 10.4052C14.0148 9.75633 14.6722 9.32067 15.3794 9.32067L15.4784 9.32323C15.7077 9.34187 15.9188 9.16518 15.9466 8.93104C16.0171 8.32947 16.0179 7.71761 15.9501 7.11169ZM8.01309 10.6854C6.54159 10.6854 5.34465 9.48843 5.34465 8.01693C5.34465 6.54549 6.54159 5.34849 8.01309 5.34849C9.48454 5.34849 10.6815 6.54549 10.6815 8.01693C10.6815 9.48843 9.48454 10.6854 8.01309 10.6854Z"
                                                fill="gray"
                                            />
                                        </svg>
                                    </button>
                                    <template #popper>
                                        <CheckboxFilter
                                            v-model="contractorFilter"
                                            compact
                                            :options="contractors"
                                            :emit-prop="'id'"
                                            :view-label="'name'"
                                            style="
                                                background-color: #fff;
                                                border-radius: 5px;
                                                padding: 10px;
                                                font-size: 14px;
                                            "
                                        >
                                            <template #default="{ option }">
                                                {{ option.name }}
                                            </template>
                                        </CheckboxFilter>
                                    </template>
                                </VDropdown>
                            </div>
                        </th>
                        <th class="control-table__cell" colspan="2">
                            <div style="display: flex; align-items: center">
                                {{ $t('adminBookControls.status') }}
                                <CheckboxFilter
                                    v-model="stateFilter"
                                    horizontal
                                    compact
                                    :options="states"
                                    :emit-prop="'name'"
                                    :view-label="'label'"
                                    style="margin-left: 10px"
                                >
                                    <template #default="{ option }">
                                        {{ option.label }}
                                    </template>
                                </CheckboxFilter>
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody v-if="books.length" class="control-table__body">
                    <ContractedBookCard
                        v-for="book in books"
                        :key="book.id"
                        :book="book"
                        :active="isBookSelected(book.id)"
                        :states="states"
                        @selected="onBookSelected"
                        @statusChanged="fetchBooks({ page: 1, page_size: books.length }, false)"
                        @metaSent="fetchBooks({ page: 1, page_size: books.length }, false)"
                    />
                </tbody>
                <tbody v-else class="control-table__body">
                    <tr v-if="!loading && !books.length" class="control-table__row">
                        <td class="control-table__cell" colspan="6">
                            <p style="color: #161838; font-size: 14px; text-align: center">
                                {{ $t('booksList.notfound') }}
                            </p>
                        </td>
                    </tr>
                </tbody>
            </table>
            <button
                v-if="canLoadMore"
                type="button"
                class="books-list__loadmore"
                :disabled="loading"
                @click.prevent="nextPage"
            >
                {{ $t('misc.loadmore') }}
            </button>
        </div>
    </div>
</template>

<script>
import ContractedBookCard from '../ContractedBookCard/ContractedBookCard';
import CheckboxFilter from '@speechki-frontend/shared/ui/CheckboxFilter';
import { Checkbox, CustomSelect } from '@speechki-frontend/shared/ui/forms';
import { Dropdown } from 'floating-vue';

import { mapActions, mapState } from 'vuex';

export default {
    name: 'ContractedBooksList',
    components: {
        ContractedBookCard,
        CustomSelect,
        CheckboxFilter,
        Checkbox,
        VDropdown: Dropdown,
    },
    data() {
        return {
            books: [],
            booksCount: 0,
            page: 1,
            pageSize: 20,
            loading: false,
            loadingSend: false,
            searchString: '',
            searchInputTimeout: null,
            selectedBooks: [],
            state: null,
            stateFilter: ['initial', 'on_ftp'],
            allSelected: false,
            contractorFilter: [],
        };
    },
    computed: {
        ...mapState({
            states: (state) => state.contractors.states,
            contractors: (state) => state.contractors.contractors,
        }),
        canLoadMore() {
            return this.page * this.pageSize < this.booksCount;
        },
        isListener() {
            return this.$store.getters.isListener;
        },
        selectedIds() {
            return this.selectedBooks.map((bc) => bc.id).join(',');
        },
        filterString() {
            return this.stateFilter.join(',');
        },
        contractorFilterString() {
            return this.contractorFilter.join(',');
        },
    },
    watch: {
        page() {
            this.fetchBooks({}, false);
        },
        searchString(newv, oldv) {
            this.page = 1;

            if (!newv && oldv) {
                this.fetchBooks();
            }
        },
        stateFilter() {
            this.page = 1;
            this.selectedBooks = [];
            this.fetchBooks({}, false);
        },
        contractorFilter() {
            this.page = 1;
            this.fetchBooks();
        },
        allSelected(value) {
            if (value) {
                this.selectedBooks = this.books.map((bc) => ({
                    id: bc.id,
                    book: bc.book.id,
                    contractor: bc.contractor.id,
                    isbnx: bc.book.isbnx,
                    contractorName: bc.contractor.name,
                }));
            } else {
                this.selectedBooks = [];
            }
        },
    },
    async created() {
        let promises = [this.fetchBooks()];

        if (!this.states.length) {
            promises.unshift(this.fetchStates());
        }

        if (!this.contractors.length) {
            promises.unshift(this.fetchContractors());
        }

        await Promise.all(promises);
    },
    methods: {
        ...mapActions(['pushToast', 'fetchStates', 'fetchContractors']),
        async fetchBooks(query = {}, preserveSelection = true) {
            try {
                this.loading = true;

                const params = {
                    page: this.page,
                    page_size: this.pageSize,
                    ordering: '-id',
                    ...query,
                };

                if (this.filterString) {
                    params.state__in = this.filterString;
                }

                if (this.contractorFilterString) {
                    params.contractor__in = this.contractorFilterString;
                }

                if (this.searchString) {
                    params.search = this.searchString;
                }

                const { results, count } = await this.$http.get('/api/v1/contractors_books/', {
                    params,
                });

                if (!preserveSelection) {
                    this.allSelected = false;
                }

                if (this.page === 1 || (query && query.page === 1)) {
                    this.books = results;
                    this.booksCount = count;
                } else {
                    this.books = [...this.books, ...results];
                }
                this.loading = false;
            } catch (error) {
                this.loading = false;
                console.log(error);
            }
        },
        nextPage() {
            this.page++;
        },
        onSearchInput() {
            clearTimeout(this.searchInputTimeout);

            this.searchInputTimeout = setTimeout(() => {
                this.fetchBooks();
            }, 250);
        },
        /**
         * { id, book, contractor, isbnx, contractorName }
         */
        onBookSelected(event) {
            let exists = this.selectedBooks.find((bc) => bc.id === event.id);

            if (exists) {
                this.selectedBooks = this.selectedBooks.filter((bc) => bc.id !== event.id);
            } else {
                this.selectedBooks.push(event);
            }
        },
        isBookSelected(id) {
            let found = this.selectedBooks.find((bc) => bc.id === id);
            return !!found;
        },
        async sendMeta() {
            try {
                if (!this.selectedBooks.length) return;

                this.loadingSend = true;

                await this.$http.post(
                    '/api/v1/contractors_books/meta/',
                    {},
                    {
                        params: {
                            id__in: this.selectedIds,
                        },
                    }
                );

                this.pushToast({
                    id: Date.now(),
                    type: 'success',
                    title: this.$t('adminBookControls.success'),
                    text: this.$t('adminBookControls.metaSuccess'),
                });

                this.loadingSend = false;
            } catch (e) {
                alert(e);
                this.loadingSend = false;
            }
        },
        async sendBook() {
            if (!this.selectedBooks.length) return;

            try {
                this.loadingSend = true;

                await this.$http.post(
                    '/api/v1/contractors_books/ftp/',
                    {},
                    {
                        params: {
                            id__in: this.selectedIds,
                        },
                    }
                );

                this.pushToast({
                    id: Date.now(),
                    type: 'success',
                    title: this.$t('adminBookControls.success'),
                    text: this.$t('adminBookControls.ftpSuccess'),
                });

                this.loadingSend = false;
            } catch (e) {
                this.loadingSend = false;
                if (e.detail && e.detail[0]) {
                    this.pushToast({
                        id: Date.now(),
                        type: 'error',
                        title: this.$t('adminBookControls.errorFtp'),
                        text: e.detail[0],
                    });
                }
            }
        },
        async setState() {
            try {
                this.loading = true;

                await this.$http.patch(
                    '/api/v1/contractors_books/state/',
                    {
                        state: this.state,
                    },
                    {
                        params: {
                            id__in: this.selectedIds,
                        },
                    }
                );

                await this.fetchBooks({ page: 1, page_size: this.books.length });

                this.state = null;

                this.loading = false;
            } catch (e) {
                this.loading = false;
                if (e.detail && e.detail[0]) {
                    this.pushToast({
                        id: Date.now(),
                        type: 'error',
                        title: this.$t('adminBookControls.errorFtp'),
                        text: e.detail[0],
                    });
                }
            }
        },
    },
};
</script>

<style src="./ContractedBooksList.scss" lang="scss"></style>
